/**
 * HTML template for the airport info view and clock.
 *
 * @property AIRPORT_INFO_TEMPLATE
 * @type {String|HTML Element}
 * @final
 */
export const AIRPORT_INFO_TEMPLATE = '' +
'<div id="airportInfo" class="notSelectable">' +
'    <div class="airportInfo-line">' +
'        <div class="airportInfo-label js-airportInfo-clock-label">TIME</div>' +
'        <div class="airportInfo-value js-airportInfo-clock-value"></div>' +
'    </div>' +
'    <div class="airportInfo-line">' +
'        <div class="airportInfo-label js-airportInfo-wind-label">WIND</div>' +
'        <div class="airportInfo-value js-airportInfo-wind-value"></div>' +
'    </div>' +
'    <div class="airportInfo-line">' +
'        <div class="airportInfo-label js-airportInfo-altimeter-label">ALTIM</div>' +
'        <div class="airportInfo-value js-airportInfo-altimeter-value"></div>' +
'    </div>' +
'    <div class="airportInfo-line">' +
'        <div class="airportInfo-label js-airportInfo-elevation-label">ELEV</div>' +
'        <div class="airportInfo-value js-airportInfo-elevation-value"></div>' +
'    </div>' +
'</div>';
